import { useContext } from 'react'
import { NativeLayerContextProvider } from '../contexts/NativeLayerContext'
import { NativeLayerContext } from '../types/nativeLayer'

/**
 * Custom hook to access NativeLayer functionality
 * Provides methods to communicate with the mobile app's native layer
 * All methods automatically check if the native layer is ready before executing
 */
export const useNativeLayer = (): NativeLayerContext => {
	const context = useContext(NativeLayerContextProvider)

	if (!context) {
		throw new Error('useNativeLayer must be used within a NativeLayerProvider')
	}

	return context
}
